import { useState } from 'react';
import { TextField } from '@tryhackme/thm-ui-components';
import { faCircleMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OperatorType } from 'src/common/enums/categorization-dashboard';
import { useFieldArray, useFormContext, useWatch } from 'src/common/form';
import { StyledButton } from '../accordion/accordion.styles';
import { ConditionValueProps } from './value.types';
import { Container, ValueContainer } from './value.styles';
export const ConditionValue = ({
  path
}: ConditionValueProps) => {
  const {
    control,
    register
  } = useFormContext();
  const [isAutoFocused, setIsAutoFocused] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [operator] = useWatch({
    control,
    name: [`${path}.operator`]
  });
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: `${path}.value`
  });
  const handleAddValue = () => {
    append('');
    setIsAutoFocused(true);
  };
  if (operator !== OperatorType.ANY && operator !== OperatorType.ALL) {
    return <TextField {...register(`${path}.value`)} data-testid="value" id="value" placeholder="Value" variant="input" isRequired maxLength={500} />;
  }
  return <Container data-sentry-element="Container" data-sentry-component="ConditionValue" data-sentry-source-file="value.tsx">
      {fields.map((item, index) => <ValueContainer key={item.id}>
          <TextField {...register(`${path}.value.${index}`)} placeholder="Value" variant="input" isRequired maxLength={500} autoFocus={isAutoFocused} />

          <StyledButton variant="text" color="secondary" onClick={() => remove(index)}>
            <FontAwesomeIcon icon={faCircleMinus} />
          </StyledButton>
        </ValueContainer>)}

      <StyledButton variant="text" color="secondary" size="small" onClick={handleAddValue} data-sentry-element="StyledButton" data-sentry-source-file="value.tsx">
        <FontAwesomeIcon icon={faPlus} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="value.tsx" />
        Add value
      </StyledButton>
    </Container>;
};